import { scaleLinear } from 'd3'
import type { ChartOptions, Settings } from '../../schema/types.ts'

export default function getScales(
    settings: Settings,
    chartOptions: ChartOptions
) {
    const { vizWidth, vizHeight } = settings
    const { pitcherView } = chartOptions

    const xyRatio = vizWidth / vizHeight

    const xDomainAbs = 3.75
    const xDomain = pitcherView
        ? [xDomainAbs, -xDomainAbs]
        : [-xDomainAbs, xDomainAbs]
    // const yDomain = strikeZone === 'relative' ? [-4, 4] : [-1, 7]
    const yDomain = [-1, 6.5]

    const scaledWidth = Math.abs(xDomain[1] - xDomain[0])
    const scaledHeight = Math.abs(yDomain[1] - yDomain[0])
    const scaledRatio = scaledWidth / scaledHeight

    if (scaledRatio > xyRatio) {
        const newHeight = scaledWidth / xyRatio
        const nudge = (newHeight - scaledHeight) / 2
        yDomain[0] -= nudge
        yDomain[1] += nudge
    } else if (scaledRatio < xyRatio) {
        const newWidth = scaledHeight / xyRatio
        const nudge = (newWidth - scaledWidth) / 2
        xDomain[0] -= nudge
        xDomain[1] += nudge
    }

    if (chartOptions.pitcherPerspective) {
        const [xMin, xMax] = xDomain
        xDomain[0] = xMax
        xDomain[1] = xMin
    }
    // These scales should have the same pixel to ft ratio
    const xScale = scaleLinear().range([0, vizWidth]).domain(xDomain)
    const yScale = scaleLinear().range([vizHeight, 0]).domain(yDomain)

    return { xScale, yScale }
}
